import { useQuery } from "@tanstack/react-query";
import { listDemos } from "@/lib/api";

export function useDemos() {
  return useQuery({
    queryKey: ["demos"],
    queryFn: listDemos,
    staleTime: 10 * 60 * 1000, // 10 min — demos are immutable
    gcTime: 30 * 60 * 1000,
  });
}
